import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Penggunaan Fitur"),
  /*#__PURE__*/_createElementVNode("hr", { class: "text-muted mt-6" })
], -1)
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Status Penggunaan")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-auto fs-6 pt-4" }, " Konfigurasikan Penggunaan Fitur ", -1)
const _hoisted_11 = {
  key: 0,
  class: "btn btn-sm btn-secondary col col-lg-2",
  type: "button",
  style: {"width":"75px"},
  disabled: ""
}
const _hoisted_12 = {
  key: 1,
  class: "btn btn-sm btn-secondary col col-lg-2",
  type: "button",
  style: {"width":"125px"},
  disabled: ""
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_14 = { class: "container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Transaksional")
], -1)
const _hoisted_18 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_19 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_20 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Tagihan Digital", -1)
const _hoisted_25 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_26 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_27 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Pembayaran Otomatis", -1)
const _hoisted_31 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_32 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_33 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Auto Block Transaksi", -1)
const _hoisted_37 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_38 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_39 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_42 = { class: "container" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Layanan Berbayar")
], -1)
const _hoisted_46 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_47 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_48 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Top Up Manual", -1)
const _hoisted_53 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_54 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_55 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Custom Aplikasi", -1)
const _hoisted_59 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_60 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_61 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "PPDB", -1)
const _hoisted_65 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_66 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_67 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_70 = { class: "container" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_72 = { class: "row" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Absensi")
], -1)
const _hoisted_74 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_75 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_76 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_79 = { class: "row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Absensi", -1)
const _hoisted_81 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_82 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_83 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_85 = { class: "row" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Absensi Wajah", -1)
const _hoisted_87 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_88 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_89 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_92 = { class: "container" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-md-center" }, null, -1)
const _hoisted_94 = { class: "row" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-4" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Layanan Pendukung")
], -1)
const _hoisted_96 = { class: "col-md-auto form-check mb-6 pt-4" }
const _hoisted_97 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_98 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_101 = { class: "row" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Kalender Akademik", -1)
const _hoisted_103 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_104 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_105 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_107 = { class: "row" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col fs-4 pt-2" }, "Jadwal Pelajaran", -1)
const _hoisted_109 = { class: "col-md-auto form-check mb-6 pt-2" }
const _hoisted_110 = {
  key: 0,
  disabled: "",
  class: "btn btn-sm m-1 text-success",
  style: {"background":"#00ff18","color":"black !important"}
}
const _hoisted_111 = {
  key: 1,
  disabled: "",
  class: "btn btn-sm m-1 text-danger",
  style: {"background":"#ff2626","color":"white !important"}
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "col col-lg-2" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("hr", { class: "text-muted" }, null, -1)
const _hoisted_114 = {
  key: 0,
  style: {"position":"fixed","z-index":"9999","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0.5)","display":"table","transition":"opacity 0.3s ease"}
}
const _hoisted_115 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_116 = { class: "modal-content rounded" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_118 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_119 = { class: "row" }
const _hoisted_120 = { class: "col-l-6" }
const _hoisted_121 = { class: "row-l-6" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-2" }, "Konfirmasi", -1)
const _hoisted_123 = {
  class: "form-label text-dark fs-5",
  style: {"font-weight":"400"}
}
const _hoisted_124 = /*#__PURE__*/_createTextVNode(" Apakah anda yakin akan menggunakan Fitur ")
const _hoisted_125 = { style: {"font-weight":"800"} }
const _hoisted_126 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_127 = { class: "d-flex pt-5" }
const _hoisted_128 = { class: "form-check" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Aktif ", -1)
const _hoisted_130 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_131 = { class: "form-check" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Tidak Aktif ", -1)
const _hoisted_133 = { class: "modal-footer justify-content-center" }
const _hoisted_134 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_aktif",
  ref: "uploadModalRef"
}
const _hoisted_135 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_136 = { class: "modal-content rounded" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_138 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "col-l-6" }
const _hoisted_141 = { class: "row-l-6" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-2" }, "Konfirmasi", -1)
const _hoisted_143 = {
  class: "form-label text-dark fs-5",
  style: {"font-weight":"400"}
}
const _hoisted_144 = /*#__PURE__*/_createTextVNode(" Apakah anda yakin akan menggunakan Fitur ")
const _hoisted_145 = { style: {"font-weight":"800"} }
const _hoisted_146 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_147 = { class: "d-flex pt-5" }
const _hoisted_148 = { class: "form-check" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Aktif ", -1)
const _hoisted_150 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_151 = { class: "form-check" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Tidak Aktif ", -1)
const _hoisted_153 = { class: "modal-footer justify-content-center" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_155 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_topup",
  ref: "uploadModalRef"
}
const _hoisted_156 = { class: "modal-dialog modal-dialog-centered modal-md" }
const _hoisted_157 = { class: "modal-content rounded" }
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-left" }, null, -1)
const _hoisted_159 = { class: "modal-md scroll-y px-2 px-lg-5 pt-0 pb-5" }
const _hoisted_160 = { class: "row" }
const _hoisted_161 = { class: "col-sm-12" }
const _hoisted_162 = { class: "row-sm-12" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-2" }, "Top Up Manual", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Pembayaran Manual", -1)
const _hoisted_165 = { class: "d-flex pt-5" }
const _hoisted_166 = { class: "form-check" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Aktif ", -1)
const _hoisted_168 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_169 = { class: "form-check" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Tidak Aktif ", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Biaya Admin Top Up", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Batas Pembayaran", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Upload Dokumen", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Catatan", -1)
const _hoisted_175 = { class: "modal-footer justify-content-center" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger text-center",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_177 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_customapp",
  ref: "uploadModalRef"
}
const _hoisted_178 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_179 = { class: "modal-content rounded" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header pb-0 border-0 justify-content-left" }, null, -1)
const _hoisted_181 = { class: "modal-md scroll-y px-2 px-lg-5 pt-0 pb-5" }
const _hoisted_182 = { class: "row" }
const _hoisted_183 = { class: "col-sm-12" }
const _hoisted_184 = { class: "row-sm-12" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-2" }, "Custom Aplikasi", -1)
const _hoisted_186 = { class: "col-6" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Custom Aplikasi", -1)
const _hoisted_188 = { class: "d-flex pt-5" }
const _hoisted_189 = { class: "form-check" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Aktif ", -1)
const _hoisted_191 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_192 = { class: "form-check" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Tidak Aktif ", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Nama Aplikasi", -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Biaya Custom Aplikasi", -1)
const _hoisted_196 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Tipe Pembayaran", -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Tipe Pembayaran", -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("option", {
  value: "GRATIS",
  key: "GRATIS"
}, "GRATIS", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("option", {
  value: "SEKALI_BAYAR",
  key: "SEKALI BAYAR"
}, " SEKALI BAYAR ", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("option", {
  value: "BULANAN",
  key: "BULANAN"
}, "BULANAN", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("option", {
  value: "TAHUNAN",
  key: "TAHUNAN"
}, "TAHUNAN", -1)
const _hoisted_202 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Upload Dokumen", -1)
const _hoisted_203 = { class: "col-6" }
const _hoisted_204 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Batas Pembayaran", -1)
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Tanggal Relase", -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Catatan", -1)
const _hoisted_207 = { class: "modal-footer justify-content-center" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-danger text-center",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end py-2 px-12" }, null, -1)
const _hoisted_210 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_211 = { class: "" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("div", { class: "card-body py-3" }, null, -1)
const _hoisted_213 = { class: "row" }
const _hoisted_214 = { class: "col-sm-12" }
const _hoisted_215 = { class: "row px-4" }
const _hoisted_216 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, " Custom Aplikasi ")
], -1)
const _hoisted_217 = { class: "row px-6" }
const _hoisted_218 = { class: "form-check col-md-2" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Aktif ", -1)
const _hoisted_220 = { class: "form-check col-md-2" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Tidak Aktif ", -1)
const _hoisted_222 = { class: "col-6 px-3" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4 required" }, "Nama Aplikasi", -1)
const _hoisted_224 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_225 = { class: "fv-help-block" }
const _hoisted_226 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4 required" }, "Tipe Pembayaran", -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Tipe Pembayaran", -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("option", {
  value: "SEKALI_BAYAR",
  key: "SEKALIBAYAR"
}, " SEKALI BAYAR ", -1)
const _hoisted_230 = /*#__PURE__*/_createElementVNode("option", {
  value: "GRATIS",
  key: "GRATIS"
}, "GRATIS", -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("option", {
  value: "BULANAN",
  key: "BULANAN"
}, "BULANAN", -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("option", {
  value: "TAHUNAN",
  key: "TAHUNAN"
}, "TAHUNAN", -1)
const _hoisted_233 = { class: "fv-plugins-message-container" }
const _hoisted_234 = { class: "fv-help-block" }
const _hoisted_235 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_236 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4" }, "Mulai Pembayaran", -1)
const _hoisted_237 = ["type", "disabled", "placeholder", "v-model"]
const _hoisted_238 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_239 = { class: "fv-help-block" }
const _hoisted_240 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_241 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4" }, "Tanggal PKS", -1)
const _hoisted_242 = { class: "fv-plugins-message-container" }
const _hoisted_243 = { class: "fv-help-block" }
const _hoisted_244 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_245 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4 required" }, "Upload Dokumen", -1)
const _hoisted_246 = { style: {} }
const _hoisted_247 = ["disabled"]
const _hoisted_248 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_249 = { class: "fv-help-block" }
const _hoisted_250 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_251 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4" }, "Alamat Aplikasi", -1)
const _hoisted_252 = { class: "col-6" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4" }, "Tanggal Relase", -1)
const _hoisted_254 = ["disabled"]
const _hoisted_255 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4" }, "Potongan", -1)
const _hoisted_256 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 required" }, "Harga", -1)
const _hoisted_257 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_258 = /*#__PURE__*/_createElementVNode("div", { class: "fv-help-block" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","font-style":"italic"} }, /*#__PURE__*/_toDisplayString("Input minimal 0"))
], -1)
const _hoisted_259 = [
  _hoisted_258
]
const _hoisted_260 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-4 mt-4" }, "Catatan", -1)
const _hoisted_261 = ["disabled"]
const _hoisted_262 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_263 = { class: "fv-help-block" }
const _hoisted_264 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_265 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_266 = { class: "fv-help-block" }
const _hoisted_267 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_268 = { class: "d-flex flex-row-reverse mt-4" }
const _hoisted_269 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)
const _hoisted_270 = /*#__PURE__*/_createTextVNode(" Loading.. ")
const _hoisted_271 = [
  _hoisted_269,
  _hoisted_270
]
const _hoisted_272 = {
  key: 2,
  style: {"position":"fixed","z-index":"9999","top":"0","left":"0","width":"100%","height":"100%","background-color":"rgba(0, 0, 0, 0.5)","display":"table","transition":"opacity 0.3s ease"}
}
const _hoisted_273 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_274 = { class: "modal-content rounded" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header px-5 pt-4 pb-0 border-0 justify-content-left" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-2" }, "Top Up Manual")
], -1)
const _hoisted_276 = /*#__PURE__*/_createElementVNode("hr", {
  class: "m-1",
  style: {"border":"1px solid darkgrey"}
}, null, -1)
const _hoisted_277 = { class: "modal-md scroll-y px-2 px-lg-5 pt-0 pb-5" }
const _hoisted_278 = { class: "row" }
const _hoisted_279 = { class: "col-sm-12" }
const _hoisted_280 = { class: "row px-2" }
const _hoisted_281 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5 required" }, "Pembayaran Manual", -1)
const _hoisted_282 = { class: "d-flex pt-5" }
const _hoisted_283 = { class: "form-check" }
const _hoisted_284 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Aktif ", -1)
const _hoisted_285 = /*#__PURE__*/_createTextVNode("          ")
const _hoisted_286 = { class: "form-check" }
const _hoisted_287 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " Tidak Aktif ", -1)
const _hoisted_288 = { class: "col-6" }
const _hoisted_289 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5 required" }, "Biaya Admin Top Up", -1)
const _hoisted_290 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_291 = { class: "fv-help-block" }
const _hoisted_292 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_293 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Biaya Admin dari Sekolah", -1)
const _hoisted_294 = {
  key: 1,
  class: "fv-plugins-message-container"
}
const _hoisted_295 = { class: "fv-help-block" }
const _hoisted_296 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Biaya Admin dari Merchant", -1)
const _hoisted_298 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_299 = { class: "fv-help-block" }
const _hoisted_300 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_301 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5" }, "Total Biaya admin", -1)
const _hoisted_302 = { class: "col-6" }
const _hoisted_303 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 pt-5 required" }, "Upload Dokumen", -1)
const _hoisted_304 = { style: {} }
const _hoisted_305 = ["disabled"]
const _hoisted_306 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_307 = { class: "fv-help-block" }
const _hoisted_308 = { style: {"color":"red","font-style":"italic"} }
const _hoisted_309 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass(`fs-5 pt-5`)
}, "Catatan", -1)
const _hoisted_310 = ["disabled"]
const _hoisted_311 = { class: "modal-footer justify-content-center" }
const _hoisted_312 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)
const _hoisted_313 = /*#__PURE__*/_createTextVNode(" Loading.. ")
const _hoisted_314 = [
  _hoisted_312,
  _hoisted_313
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    (!_ctx.modalCustomApp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  (_ctx.statusAllFitur == true)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_11, " Aktif "))
                    : (_openBlock(), _createElementBlock("button", _hoisted_12, " Tidak Aktif "))
                ]),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.statusTransaksional == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_19, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_20, " Tidak Aktif "))
                  ]),
                  _hoisted_21
                ]),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    (_ctx.detailFiturSekolah.digitalInvoice == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_26, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_27, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'digitalInvoice',
                    _ctx.detailFiturSekolah.digitalInvoice,
                    'Tagihan Digital'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.detailFiturSekolah.automaticPayment == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_32, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_33, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'automaticPayment',
                    _ctx.detailFiturSekolah.automaticPayment,
                    'Pembayaran Otomatis'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_34
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createElementVNode("div", _hoisted_37, [
                    (_ctx.detailFiturSekolah.blockCardTransaction == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_38, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_39, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'blockCardTransaction',
                    _ctx.detailFiturSekolah.blockCardTransaction,
                    'Auto Block Transaksi'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_40
                ]),
                _hoisted_41
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    (_ctx.statusLayananBerbayar == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_47, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_48, " Tidak Aktif "))
                  ]),
                  _hoisted_49
                ]),
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", _hoisted_53, [
                    (_ctx.topUpManual.topUpManual == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_54, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_55, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (
                _ctx.setValueUpdateModal(
                  'topUpManual',
                  _ctx.topUpManual.topUpManual,
                  ''
                )
                ))
                    }, " Ubah ")
                  ]),
                  _hoisted_56
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("div", _hoisted_59, [
                    (_ctx.customApps.customApps == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_60, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_61, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (
                _ctx.setValueUpdateModal(
                  'customApps',
                  _ctx.customApps.customApps,
                  'Custom Aplikasi'
                )
                ))
                    }, " Ubah ")
                  ]),
                  _hoisted_62
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("div", _hoisted_65, [
                    (_ctx.detailFiturSekolah.ppdb == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_66, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_67, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (
                _ctx.setValueUpdateModal('ppdb', _ctx.detailFiturSekolah.ppdb, 'PPDB')
                ))
                    }, " Ubah ")
                  ]),
                  _hoisted_68
                ]),
                _hoisted_69
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("div", _hoisted_74, [
                    (_ctx.statusAbsensi == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_75, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_76, " Tidak Aktif "))
                  ]),
                  _hoisted_77
                ]),
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _hoisted_80,
                  _createElementVNode("div", _hoisted_81, [
                    (_ctx.detailFiturSekolah.attendance == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_82, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_83, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'attendance',
                    _ctx.detailFiturSekolah.attendance,
                    'Absensi'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_84
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _hoisted_86,
                  _createElementVNode("div", _hoisted_87, [
                    (_ctx.detailFiturSekolah.faceRecognition == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_88, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_89, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'faceRecognition',
                    _ctx.detailFiturSekolah.faceRecognition,
                    'Absensi Wajah'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_90
                ]),
                _hoisted_91
              ]),
              _createElementVNode("div", _hoisted_92, [
                _hoisted_93,
                _createElementVNode("div", _hoisted_94, [
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    (_ctx.statusLayananPendukung == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_97, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_98, " Tidak Aktif "))
                  ]),
                  _hoisted_99
                ]),
                _hoisted_100,
                _createElementVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("div", _hoisted_103, [
                    (_ctx.detailFiturSekolah.calendarAcademic == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_104, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_105, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'calendarAcademic',
                    _ctx.detailFiturSekolah.calendarAcademic,
                    'Kalender Akademik'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_106
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createElementVNode("div", _hoisted_109, [
                    (_ctx.detailFiturSekolah.scheduleAcademic == true)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_110, " Aktif "))
                      : (_openBlock(), _createElementBlock("button", _hoisted_111, " Tidak Aktif ")),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#kt_modal_aktif",
                      type: "button",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (
                  _ctx.setValueUpdateModal(
                    'scheduleAcademic',
                    _ctx.detailFiturSekolah.scheduleAcademic,
                    'Jadwal Pelajaran'
                  )
                  ))
                    }, " Ubah ")
                  ]),
                  _hoisted_112
                ]),
                _hoisted_113
              ])
            ]),
            (_ctx.modalPPDB)
              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _hoisted_117,
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("div", _hoisted_119, [
                          _createElementVNode("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              _hoisted_122,
                              _createElementVNode("div", _hoisted_123, [
                                _hoisted_124,
                                _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.modalFitur.textTittleModal), 1),
                                _hoisted_126
                              ]),
                              _createElementVNode("div", _hoisted_127, [
                                _createElementVNode("div", _hoisted_128, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                    value: true
                                  }, null, 512), [
                                    [_vModelRadio, _ctx.modalFitur.valueFitur]
                                  ]),
                                  _hoisted_129
                                ]),
                                _hoisted_130,
                                _createElementVNode("div", _hoisted_131, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                    value: false
                                  }, null, 512), [
                                    [_vModelRadio, _ctx.modalFitur.valueFitur]
                                  ]),
                                  _hoisted_132
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.closeModal()))
                        }, " Batal "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          "data-bs-dismiss": "modal",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveModalConfirmation()))
                        }, " Simpan ")
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("div", _hoisted_136, [
                  _hoisted_137,
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, [
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("div", _hoisted_141, [
                          _hoisted_142,
                          _createElementVNode("div", _hoisted_143, [
                            _hoisted_144,
                            _createElementVNode("span", _hoisted_145, _toDisplayString(_ctx.modalFitur.textTittleModal), 1),
                            _hoisted_146
                          ]),
                          _createElementVNode("div", _hoisted_147, [
                            _createElementVNode("div", _hoisted_148, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                value: true
                              }, null, 512), [
                                [_vModelRadio, _ctx.modalFitur.valueFitur]
                              ]),
                              _hoisted_149
                            ]),
                            _hoisted_150,
                            _createElementVNode("div", _hoisted_151, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                value: false
                              }, null, 512), [
                                [_vModelRadio, _ctx.modalFitur.valueFitur]
                              ]),
                              _hoisted_152
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    _hoisted_154,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.saveModalConfirmation()))
                    }, " Simpan ")
                  ])
                ])
              ])
            ], 512),
            _createElementVNode("div", _hoisted_155, [
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("div", _hoisted_157, [
                  _hoisted_158,
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _hoisted_163,
                          _hoisted_164,
                          _createElementVNode("div", _hoisted_165, [
                            _createElementVNode("div", _hoisted_166, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                value: true
                              }, null, 512), [
                                [_vModelRadio, _ctx.modalFitur.valueFitur]
                              ]),
                              _hoisted_167
                            ]),
                            _hoisted_168,
                            _createElementVNode("div", _hoisted_169, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "radio",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                value: false
                              }, null, 512), [
                                [_vModelRadio, _ctx.modalFitur.valueFitur]
                              ]),
                              _hoisted_170
                            ])
                          ]),
                          _hoisted_171,
                          _createVNode(_component_Field, {
                            type: "number",
                            name: "a",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.topUpManual.topUpManualFee,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.topUpManual.topUpManualFee) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_172,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "b",
                            class: "form-control form-control-lg",
                            modelValue: _ctx.topUpManual.topUpManualDueDate,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.topUpManual.topUpManualDueDate) = $event)),
                            disabled: ""
                          }, null, 8, ["modelValue"]),
                          _hoisted_173,
                          (_openBlock(), _createElementBlock("input", {
                            name: "file2",
                            type: "file",
                            class: "form-control form-control-lg",
                            onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleFileUploadTopUp($event))),
                            key: _ctx.fileInputKey
                          }, null, 32)),
                          _hoisted_174,
                          _withDirectives(_createElementVNode("textarea", {
                            type: "textarea",
                            name: "c",
                            class: "form-control form-control-lg",
                            style: {"height":"150px"},
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.topUpManual.topUpManualNote) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.topUpManual.topUpManualNote]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_175, [
                    _hoisted_176,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.saveTopUpManual()))
                    }, " Simpan ")
                  ])
                ])
              ])
            ], 512),
            _createElementVNode("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("div", _hoisted_179, [
                  _hoisted_180,
                  _createElementVNode("div", _hoisted_181, [
                    _createElementVNode("div", _hoisted_182, [
                      _createElementVNode("div", _hoisted_183, [
                        _createElementVNode("div", _hoisted_184, [
                          _hoisted_185,
                          _createElementVNode("div", _hoisted_186, [
                            _hoisted_187,
                            _createElementVNode("div", _hoisted_188, [
                              _createElementVNode("div", _hoisted_189, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                  value: true
                                }, null, 512), [
                                  [_vModelRadio, _ctx.modalFitur.valueFitur]
                                ]),
                                _hoisted_190
                              ]),
                              _hoisted_191,
                              _createElementVNode("div", _hoisted_192, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                                  value: false
                                }, null, 512), [
                                  [_vModelRadio, _ctx.modalFitur.valueFitur]
                                ]),
                                _hoisted_193
                              ])
                            ]),
                            _hoisted_194,
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "a",
                              class: "form-control form-control-lg",
                              modelValue: _ctx.customApps.customAppsName,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.customApps.customAppsName) = $event))
                            }, null, 8, ["modelValue"]),
                            _hoisted_195,
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "a",
                              class: "form-control form-control-lg",
                              modelValue: _ctx.customApps.customAppsFee,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.customApps.customAppsFee) = $event))
                            }, null, 8, ["modelValue"]),
                            _hoisted_196,
                            _createVNode(_component_Field, {
                              as: "select",
                              class: "form-select form-select-lg fw-bold",
                              name: "gender",
                              placeholder: "Pilih Bulanan / Tahunan",
                              autocomplete: "off",
                              modelValue: _ctx.customApps.customAppsPaymentType,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.customApps.customAppsPaymentType) = $event))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_197,
                                _hoisted_198,
                                _hoisted_199,
                                _hoisted_200,
                                _hoisted_201
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _hoisted_202,
                            (_openBlock(), _createElementBlock("input", {
                              name: "file2",
                              type: "file",
                              class: "form-control form-control-lg",
                              onChange: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleFileUploadCustomApps($event))),
                              key: _ctx.fileInputKey
                            }, null, 32))
                          ]),
                          _createElementVNode("div", _hoisted_203, [
                            _hoisted_204,
                            _createVNode(_component_Field, {
                              type: "text",
                              name: "b",
                              class: "form-control form-control-lg",
                              modelValue: _ctx.customApps.customAppsDueDate,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.customApps.customAppsDueDate) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"]),
                            _hoisted_205,
                            _withDirectives(_createElementVNode("input", {
                              name: "cc",
                              type: "date",
                              class: "form-control form-control-lg",
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.customApps.customAppsReleaseDate) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.customApps.customAppsReleaseDate]
                            ]),
                            _hoisted_206,
                            _withDirectives(_createElementVNode("textarea", {
                              type: "textarea",
                              name: "c",
                              class: "form-control form-control-lg",
                              style: {"height":"150px"},
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.customApps.customAppsNote) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.customApps.customAppsNote]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_207, [
                    _hoisted_208,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.saveCustomApps()))
                    }, " Simpan ")
                  ])
                ])
              ])
            ], 512),
            _hoisted_209
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_210, [
          _createElementVNode("div", _hoisted_211, [
            _hoisted_212,
            _createElementVNode("div", _hoisted_213, [
              _createElementVNode("div", _hoisted_214, [
                _createElementVNode("div", _hoisted_215, [
                  _hoisted_216,
                  _createElementVNode("div", _hoisted_217, [
                    _createElementVNode("div", _hoisted_218, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                        value: true,
                        onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.activeRadioButtonSelected && _ctx.activeRadioButtonSelected(...args)))
                      }, null, 512), [
                        [_vModelRadio, _ctx.modalFitur.valueFitur]
                      ]),
                      _hoisted_219
                    ]),
                    _createElementVNode("div", _hoisted_220, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "radio",
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                        value: false,
                        onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.nonActiveRadioButtonSelected && _ctx.nonActiveRadioButtonSelected(...args)))
                      }, null, 512), [
                        [_vModelRadio, _ctx.modalFitur.valueFitur]
                      ]),
                      _hoisted_221
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_222, [
                    _hoisted_223,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "a",
                      class: "form-control form-control-lg",
                      disabled: _ctx.isDisabled,
                      placeholder: "Isi Nama Aplikasi",
                      modelValue: _ctx.customApps.customAppsName,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.customApps.customAppsName) = $event)),
                      onChange: _cache[39] || (_cache[39] = ($event: any) => (_ctx.isEdit = true))
                    }, null, 8, ["disabled", "modelValue"]),
                    (_ctx.customApps.customAppsName == '' && _ctx.errorMsg.error != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                          _createElementVNode("div", _hoisted_225, [
                            _createElementVNode("span", _hoisted_226, _toDisplayString(_ctx.errorMsg.error), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_227,
                    _createVNode(_component_Field, {
                      as: "select",
                      class: "form-select form-select-lg fw-bold",
                      name: "gender",
                      placeholder: "Pilih Tipe Pembayaran",
                      autocomplete: "off",
                      disabled: _ctx.isDisabled,
                      modelValue: _ctx.customApps.customAppsPaymentType,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.customApps.customAppsPaymentType) = $event)),
                      onChange: _cache[41] || (_cache[41] = ($event: any) => (_ctx.pilihType($event)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_228,
                        _hoisted_229,
                        _hoisted_230,
                        _hoisted_231,
                        _hoisted_232
                      ]),
                      _: 1
                    }, 8, ["disabled", "modelValue"]),
                    _createElementVNode("div", _hoisted_233, [
                      _createElementVNode("div", _hoisted_234, [
                        _createElementVNode("span", _hoisted_235, _toDisplayString(_ctx.errorMsg.customAppsPaymentType), 1)
                      ])
                    ]),
                    _hoisted_236,
                    _createElementVNode("input", {
                      type: _ctx.isClik ? 'text' : 'month',
                      onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.handlestartdatenull($event))),
                      name: "a",
                      class: "form-control form-control-lg",
                      disabled: _ctx.isDisabled || _ctx.customApps.customAppsPaymentType == 'GRATIS'
                  ,
                      onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.clearErrorMessage($event))),
                      placeholder: _ctx.customApps.customAppsStartPaymentDate
    ? _ctx.formatTanggal(_ctx.customApps.customAppsStartPaymentDate)
    : 'Pilih Tanggal'
    ,
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.isClik = false)),
                      "v-model": _ctx.customApps.customAppsStartPaymentDate
                    }, null, 40, _hoisted_237),
                    (_ctx.customApps.customAppsPaymentType !== 'GRATIS')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_238, [
                          _createElementVNode("div", _hoisted_239, [
                            _createElementVNode("span", _hoisted_240, _toDisplayString(_ctx.errorMsg.customAppsStartPaymentDate), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_241,
                    _createVNode(_component_el_date_picker, {
                      disabled: _ctx.isDisabled,
                      "picker-options": "",
                      modelValue: _ctx.dateAll,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.dateAll) = $event)),
                      type: "daterange",
                      "start-placeholder": "Tanggal Awal",
                      "end-placeholder": "Tanggal Akhir",
                      "value-format": "YYYY-MM-DD",
                      onChange: _cache[46] || (_cache[46] = ($event: any) => (_ctx.pilihTanggalAll()))
                    }, null, 8, ["disabled", "modelValue"]),
                    _createElementVNode("div", _hoisted_242, [
                      _createElementVNode("div", _hoisted_243, [
                        _createElementVNode("span", _hoisted_244, _toDisplayString(_ctx.errorMsg.errorTglPks), 1)
                      ])
                    ]),
                    _hoisted_245,
                    _createElementVNode("div", _hoisted_246, [
                      (_ctx.customApps.customAppsDocAgreement)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-success text-center mx-3 my-2",
                            onClick: _cache[47] || (_cache[47] = ($event: any) => (
                    _ctx.downloadDoc(
                      _ctx.customApps.customAppsDocAgreement,
                      'Dokumen Pendukung Custom Apps'
                    )
                    ))
                          }, " Unduh Dokumen Pendukung "))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(), _createElementBlock("input", {
                      name: "file2",
                      type: "file",
                      class: "form-control form-control-lg",
                      disabled: _ctx.isDisabled,
                      accept: ".jpg, .jpeg, .pdf, .png, .doc, .docx",
                      onChange: _cache[48] || (_cache[48] = ($event: any) => (_ctx.handleFileUploadCustomApps($event))),
                      key: _ctx.fileInputKey,
                      placeholder: "Upload Dokumen"
                    }, null, 40, _hoisted_247)),
                    (_ctx.customApps.customAppsDocAgreement == '' &&
                _ctx.errorMsg.errorFile != ''
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                          _createElementVNode("div", _hoisted_249, [
                            _createElementVNode("span", _hoisted_250, _toDisplayString(_ctx.errorMsg.errorFile), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_251,
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "a",
                      class: "form-control form-control-lg",
                      placeholder: "Isi Alamat Aplikasi",
                      onChange: _cache[49] || (_cache[49] = ($event: any) => (_ctx.isEdit = true)),
                      disabled: _ctx.isDisabled,
                      modelValue: _ctx.customApps.customAppsUrl,
                      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.customApps.customAppsUrl) = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_252, [
                    _hoisted_253,
                    _withDirectives(_createElementVNode("input", {
                      name: "cc",
                      placeholder: "Pilih Tanggal",
                      type: "date",
                      class: "form-control form-control-lg",
                      onChange: _cache[51] || (_cache[51] = ($event: any) => (_ctx.isEdit = true)),
                      disabled: _ctx.isDisabled,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.customApps.customAppsReleaseDate) = $event))
                    }, null, 40, _hoisted_254), [
                      [_vModelText, _ctx.customApps.customAppsReleaseDate]
                    ]),
                    _hoisted_255,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-lg fw-bold",
                      name: "gender",
                      placeholder: "Potongan",
                      autocomplete: "off",
                      disabled: true,
                      modelValue: _ctx.customApps.customAppsPotongan,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.customApps.customAppsPotongan) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_256,
                    _createVNode(_component_Field, {
                      type: "number",
                      onBlur: _cache[54] || (_cache[54] = ($event: any) => (_ctx.keydown($event))),
                      name: "a",
                      class: "form-control form-control-lg",
                      disabled: _ctx.isDisabled || _ctx.customApps.customAppsPaymentType == 'GRATIS'
                ,
                      placeholder: "Isi Harga",
                      modelValue: _ctx.customApps.customAppsFee,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.customApps.customAppsFee) = $event))
                    }, null, 8, ["disabled", "modelValue"]),
                    (_ctx.customApps.customAppsFee < 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_257, _hoisted_259))
                      : _createCommentVNode("", true),
                    _hoisted_260,
                    _withDirectives(_createElementVNode("textarea", {
                      placeholder: "Isi Catatan",
                      type: "textarea",
                      onKeyup: _cache[56] || (_cache[56] = ($event: any) => (_ctx.catatan())),
                      name: "c",
                      class: "form-control form-control-lg",
                      style: {"height":"150px"},
                      disabled: _ctx.isDisabled,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.customApps.customAppsNote) = $event))
                    }, null, 40, _hoisted_261), [
                      [_vModelText, _ctx.customApps.customAppsNote]
                    ]),
                    (_ctx.customApps.customAppsPaymentType == 'GRATIS')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                          _createElementVNode("div", _hoisted_263, [
                            _createElementVNode("span", _hoisted_264, _toDisplayString(_ctx.errorMsg.errorCatatan), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.customApps.customAppsPaymentType == 'SEKALI_BAYAR')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                          _createElementVNode("div", _hoisted_266, [
                            _createElementVNode("span", _hoisted_267, _toDisplayString(_ctx.errorMsg.errorCatatan), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_268, [
                    (_ctx.isLoading == false || _ctx.isEdit == true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          style: {"background-color":"#3268ff","color":"white"},
                          class: "btn mx-4",
                          onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.saveCustomApps()))
                        }, " Simpan "))
                      : _createCommentVNode("", true),
                    (_ctx.isLoading == false)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          style: {"background-color":"#e50200","color":"white"},
                          class: "btn text-center",
                          onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.closeModal($event)))
                        }, " Batal "))
                      : _createCommentVNode("", true),
                    (_ctx.isLoading == true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          style: {"background-color":"#e50200","color":"white"},
                          class: "btn text-center",
                          onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.closeModal($event))),
                          disabled: ""
                        }, " Batal "))
                      : _createCommentVNode("", true),
                    (_ctx.isLoading == true)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          type: "button",
                          class: "btn btn-primary",
                          onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.saveTopUpManual())),
                          disabled: ""
                        }, _hoisted_271))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])),
    (_ctx.modalTopUp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_272, [
          _createElementVNode("div", _hoisted_273, [
            _createElementVNode("div", _hoisted_274, [
              _hoisted_275,
              _hoisted_276,
              _createElementVNode("div", _hoisted_277, [
                _createElementVNode("div", _hoisted_278, [
                  _createElementVNode("div", _hoisted_279, [
                    _createElementVNode("div", _hoisted_280, [
                      _hoisted_281,
                      _createElementVNode("div", _hoisted_282, [
                        _createElementVNode("div", _hoisted_283, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                            value: true,
                            onClick: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_ctx.activeRadioButtonSelected && _ctx.activeRadioButtonSelected(...args)))
                          }, null, 512), [
                            [_vModelRadio, _ctx.modalFitur.valueFitur]
                          ]),
                          _hoisted_284
                        ]),
                        _hoisted_285,
                        _createElementVNode("div", _hoisted_286, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.modalFitur.valueFitur) = $event)),
                            value: false,
                            onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.nonActiveRadioButtonSelected && _ctx.nonActiveRadioButtonSelected(...args)))
                          }, null, 512), [
                            [_vModelRadio, _ctx.modalFitur.valueFitur]
                          ]),
                          _hoisted_287
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_288, [
                        _hoisted_289,
                        _createVNode(_component_Field, {
                          type: "number",
                          name: "a",
                          class: "form-control form-control-lg",
                          modelValue: _ctx.topUpManual.topUpManualFee,
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.topUpManual.topUpManualFee) = $event)),
                          disabled: _ctx.isDisabled,
                          onKeyup: _cache[67] || (_cache[67] = ($event: any) => (_ctx.changebiaya()))
                        }, null, 8, ["modelValue", "disabled"]),
                        (_ctx.topUpManual.topUpManualFee < 0 && _ctx.errorMsg.error != ''
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_290, [
                              _createElementVNode("div", _hoisted_291, [
                                _createElementVNode("span", _hoisted_292, _toDisplayString(_ctx.errorMsg.error), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_293,
                        _createVNode(_component_Field, {
                          type: "number",
                          name: "a",
                          class: "form-control form-control-lg",
                          modelValue: _ctx.topUpManual.topUpManualFeeSchool,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.topUpManual.topUpManualFeeSchool) = $event)),
                          disabled: _ctx.isDisabled,
                          onKeyup: _cache[69] || (_cache[69] = ($event: any) => (_ctx.changebiaya()))
                        }, null, 8, ["modelValue", "disabled"]),
                        (_ctx.topUpManual.topUpManualFeeSchool < 0 &&
                    _ctx.errorMsg.errorTopUpBiayaAdmindariSekolah != ''
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_294, [
                              _createElementVNode("div", _hoisted_295, [
                                _createElementVNode("span", _hoisted_296, _toDisplayString(_ctx.errorMsg.errorTopUpBiayaAdmindariSekolah), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_297,
                        _createVNode(_component_Field, {
                          type: "number",
                          name: "a",
                          class: "form-control form-control-lg",
                          min: "0",
                          modelValue: _ctx.topUpManual.topUpManualFeeMerchant,
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.topUpManual.topUpManualFeeMerchant) = $event)),
                          modelModifiers: { number: true },
                          disabled: _ctx.isDisabled,
                          onBlur: _cache[71] || (_cache[71] = ($event: any) => (_ctx.emptyNull($event))),
                          onKeyup: _cache[72] || (_cache[72] = ($event: any) => (_ctx.changebiaya()))
                        }, null, 8, ["modelValue", "disabled"]),
                        (_ctx.topUpManual.topUpManualFeeMerchant <= 0 &&
                    _ctx.errorMsg.errorTopupMerchant != ''
                    )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_298, [
                              _createElementVNode("div", _hoisted_299, [
                                _createElementVNode("span", _hoisted_300, _toDisplayString(_ctx.errorMsg.errorTopupMerchant), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_301,
                        _createVNode(_component_Field, {
                          type: "number",
                          name: "a",
                          class: "form-control form-control-lg",
                          modelValue: _ctx.topUpManual.totalTopUpManualFee,
                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.topUpManual.totalTopUpManualFee) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_302, [
                        _hoisted_303,
                        _createElementVNode("div", _hoisted_304, [
                          (_ctx.topUpManual.topUpManualDocAgreement != '')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-success text-center mx-3 my-2",
                                onClick: _cache[74] || (_cache[74] = ($event: any) => (
                        _ctx.downloadDoc(
                          _ctx.topUpManual.topUpManualDocAgreement,
                          'Dokumen Pendukung Top Up Manual '
                        )
                        ))
                              }, " Unduh Dokumen Pendukung "))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(), _createElementBlock("input", {
                          name: "file2",
                          type: "file",
                          class: "form-control form-control-lg",
                          disabled: _ctx.isDisabled,
                          onChange: _cache[75] || (_cache[75] = ($event: any) => (_ctx.handleFileUploadTopUp($event))),
                          key: _ctx.fileInputKey
                        }, null, 40, _hoisted_305)),
                        (_ctx.errorMsg.errorFile != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_306, [
                              _createElementVNode("div", _hoisted_307, [
                                _createElementVNode("span", _hoisted_308, _toDisplayString(_ctx.errorMsg.errorFile), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_309,
                        _withDirectives(_createElementVNode("textarea", {
                          type: "textarea",
                          name: "c",
                          class: "form-control form-control-lg",
                          style: {"height":"150px"},
                          disabled: _ctx.isDisabled,
                          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.topUpManual.topUpManualNote) = $event))
                        }, null, 8, _hoisted_310), [
                          [_vModelText, _ctx.topUpManual.topUpManualNote]
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_311, [
                (_ctx.isLoading == false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger text-center",
                      onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.closeModal($event)))
                    }, " Batal "))
                  : _createCommentVNode("", true),
                (_ctx.isLoading == false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.saveTopUpManual()))
                    }, " Simpan "))
                  : _createCommentVNode("", true),
                (_ctx.isLoading == true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-danger text-center",
                      onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.closeModal($event))),
                      disabled: ""
                    }, " Batal "))
                  : _createCommentVNode("", true),
                (_ctx.isLoading == true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.saveTopUpManual())),
                      disabled: ""
                    }, _hoisted_314))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}